// Mocks for /api/secure/me/practitioners/*

import { delay } from './index'

function seedFor(profile) {
  if (!profile) return []
  const isSelf = profile.relation === 'SELF'
  const now = Date.now()
  const day = 86400000
  return isSelf
    ? [
        {
          practitionerId: 'prac_dr_meera',
          displayName: 'Dr. Meera Iyer',
          specialty: 'Therapist',
          brandName: profile.brandName,
          lastInteractionAt: new Date(now - 7 * day).toISOString(),
          hasSeen: true,
          hasActivePack: true,
        },
        {
          practitionerId: 'prac_dr_neha',
          displayName: 'Dr. Neha Bose',
          specialty: 'Nutritionist',
          brandName: profile.brandName,
          lastInteractionAt: new Date(now - 14 * day).toISOString(),
          hasSeen: true,
          hasActivePack: false,
        },
      ]
    : [
        {
          practitionerId: 'prac_dr_rao',
          displayName: 'Dr. Rao',
          specialty: 'Endocrinology',
          brandName: profile.brandName,
          lastInteractionAt: new Date(now - 30 * day).toISOString(),
          hasSeen: true,
          hasActivePack: false,
        },
        {
          practitionerId: 'prac_anjali',
          displayName: 'Physio Anjali',
          specialty: 'Physiotherapy',
          brandName: profile.brandName,
          lastInteractionAt: new Date(now - 45 * day).toISOString(),
          hasSeen: true,
          hasActivePack: false,
        },
      ]
}

export async function listPractitioners(profile) {
  await delay()
  return seedFor(profile)
}

export async function getPractitioner(profile, id) {
  await delay()
  const all = seedFor(profile)
  const summary = all.find((p) => p.practitionerId === id)
  if (!summary) return null
  return {
    summary,
    bio:
      'Practitioner bio surfaces from the broader practitioner directory after the booking-system migration. For now, you can message and request a session.',
    credentials: ['MBBS', 'MD'],
    languages: ['English', 'Hindi'],
    canMessage: true,
    acceptsRequests: true,
    nextAvailabilityLabel: null,
  }
}
